import { Link } from 'react-router-dom';
import '../styles/common.css';
 
const Header = ({ currentPage }) => {
    return (
        <nav id="header" className="header">
            {currentPage !== 'home' && !currentPage.startsWith('mentor') && (
                <span className="buttonqwe">
                    <Link to="/"><strong>ГЛАВНАЯ</strong></Link>
                </span>
            )}
            {currentPage !== 'biography' && !currentPage.startsWith('mentor') && (
                <span className="buttonqwe">
                    <Link to="/biography"><strong>ОБО МНЕ</strong></Link>
                </span>
            )}
            {currentPage !== 'experience' && !currentPage.startsWith('mentor') && (
                <span className="buttonqwe">
                    <Link to="/experience"><strong>ОПЫТ</strong></Link>
                </span>
            )}
            {currentPage !== 'blog' && !currentPage.startsWith('mentor') && (
                <span className="buttonqwe">
                    <Link to="/blog"><strong>БЛОГ</strong></Link>
                </span>
            )}
            {currentPage !== 'cooperation' && !currentPage.startsWith('mentor') && (
                <span className="buttonqwe">
                    <Link to="/cooperation"><strong>СОТРУДНИЧЕСТВО</strong></Link>
                </span>
            )}
            {false && currentPage !== 'mentor' && (
                <span className="buttonqwe newAlertSubject">
                    <Link to="/mentor"><strong>ХОЧУ УЧИТЬСЯ<span className='newAlert'>(NEW)</span></strong></Link>
                </span>
            )}
            {currentPage.startsWith('mentor') && (
                <span className="buttonqwe">
                    <Link to="/"><strong>О МЕНТОРЕ</strong></Link>
                </span>
            )}
            {currentPage !== 'mentorTree' && currentPage.startsWith('mentor') && (
                <span className="buttonqwe">
                    <Link to="/mentor/tree"><strong>ДЕРЕВО ПРОЕКТОВ</strong></Link>
                </span>
            )}
            {currentPage !== 'lkSettings' && currentPage.startsWith('mentor') && (
                <span className="buttonqwe">
                    <Link to="/settings"><strong>НАСТРОЙКИ</strong></Link>
                </span>
            )}
            {currentPage !== 'authorization' && currentPage.startsWith('mentor') && (
                <span className="buttonqwe">
                    <Link to="/auth"><strong>АВТОРИЗАЦИЯ</strong></Link>
                </span>
            )}
        </nav>
    );
};

export default Header;